var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMonthlyPayOrderServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 90,
    viewBox: "0 0 93 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2177_3213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.3574,
    y: 34.6982,
    width: 59.7137,
    height: 12.5713,
    rx: 6.28565,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.01172,
    y: 42.6035,
    width: 58.7672,
    height: 17.5667,
    rx: 8.78337,
    transform: "rotate(-35 5.01172 42.6035)",
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3574,
    y: 47.2705,
    width: 69.1422,
    height: 12.5713,
    rx: 6.28565,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3574,
    y: 59.8408,
    width: 62.8565,
    height: 12.5713,
    rx: 6.28565,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3574,
    y: 72.4121,
    width: 56.5709,
    height: 12.5713,
    rx: 6.28565,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6426,
    cy: 58.2707,
    rx: 25.1426,
    ry: 26.714,
    fill: "#EEC2B9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3574,
    y: 31.1318,
    width: 59.7132,
    height: 12.5712,
    rx: 6.28561,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.01562,
    y: 39.0332,
    width: 58.7668,
    height: 17.5666,
    rx: 8.78331,
    transform: "rotate(-35 5.01562 39.0332)",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3574,
    y: 43.7021,
    width: 69.1416,
    height: 12.5712,
    rx: 6.28561,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3574,
    y: 56.2734,
    width: 62.8561,
    height: 12.5712,
    rx: 6.28561,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.3574,
    y: 68.8438,
    width: 56.5704,
    height: 12.5712,
    rx: 6.28561,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6424,
    cy: 54.7021,
    rx: 25.1424,
    ry: 26.7138,
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2383 64.4749C33.9888 64.4749 44.5349 54.8822 46.1397 37.418C50.8555 44.9016 50.8555 60.8282 47.2267 75.7468",
    stroke: "#EEC2B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2177_3213",
    x: 0.385902,
    y: 0.661133,
    width: 92.2262,
    height: 92.2262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.618
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.809002
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2177_3213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2177_3213",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMonthlyPayOrderServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcMonthlyPayOrderServiceMainMobile.cb973f9a607a67f0d4ed57d1144997a6.svg";
export { ForwardRef as ReactComponent };